import { identity } from 'lodash';
import { createStore, applyMiddleware } from 'redux';
import thunk from '@wix/redux-thunk';
import { rootReducer } from './root-reducer';
import { createLiveUpdatesMiddleware } from './comments/live-updates/live-updates-middleware';
import { noopMiddleware } from './middleware/noop-middleware';
import { createCommentsService } from '../../controller/services/comments-service';
import { createVotesService } from '../../controller/services/vote-service/create-votes-service';
import { createMembersService } from '../../controller/services/members-service';
import { isMockHttpError } from '../../controller/utils/wrap-with-dev-connection-state';
export function createCommentsStore({ wixCodeApi, platformAPIs, appDefinitionId, compId, biMiddleware, actionPreconditions, isSSR, duplexerClient, sentry, devToolsApi, testMode, instanceManager, commentsWatcherMidlleware, executeBeforeCrud, logNetworkErrorsInConsole, httpClient, mocks, persistDraft, preloadedState, }) {
    // if you need this, just reenable for dev
    /*   const composeEnhancers = require('remote-redux-devtools').composeWithDevTools({
      realtime: true,
      port: 8000,
    }); */
    const composeEnhancers = identity;
    const trackError = (source) => logNetworkErrorsInConsole
        ? (error, args) => console.error(`NETWORK ERROR from ${source}\n`, error, '\nStatus', error?.response?.status, '\nRequestId', error?.response?.requestId, '\nArguments', args)
        : undefined;
    const fedopsLogger = platformAPIs?.fedOpsLoggerFactory?.getLoggerForWidget({
        appId: 'wix-comments-lib',
        widgetId: 'widget',
    });
    const createServiceErrorHandler = (serviceName) => (error, args) => {
        trackError(serviceName)?.(error, args);
        if (!isMockHttpError(error)) {
            sentry.captureException(error, { tags: { capturedBy: serviceName } });
        }
    };
    const commentsService = createCommentsService({
        fedopsLogger,
        httpClient,
        getCrudDevState: () => devToolsApi.getState().crudState,
        getFetchDevState: () => devToolsApi.getState().fetchState,
        onError: createServiceErrorHandler('comments-service'),
        mocks,
        persistDraft,
    });
    return createStore(rootReducer, preloadedState, composeEnhancers(applyMiddleware(commentsWatcherMidlleware, biMiddleware, isSSR || !duplexerClient
        ? noopMiddleware
        : createLiveUpdatesMiddleware({
            duplexerClient,
            appDefId: appDefinitionId,
            commentsService,
            onDuplexerError: (e) => {
                trackError('duplexer')?.(e, undefined);
                sentry.captureException(e, { tags: { capturedBy: 'live updates middleware' } });
            },
        }), thunk.withExtraArgument({
        wixCodeApi,
        platformAPIs,
        compId,
        commentsService,
        votesService: createVotesService({
            httpClient,
            getDevState: () => devToolsApi.getState().crudState,
            onError: createServiceErrorHandler('votes-service'),
        }),
        membersService: createMembersService({
            httpClient,
            getDevState: () => devToolsApi.getState().crudState,
            onError: createServiceErrorHandler('members-service'),
        }),
        actionPreconditions,
        httpClient,
        testMode,
        instanceManager,
        executeBeforeCrud,
        appDefinitionId,
    }))));
}
//# sourceMappingURL=create-comments-store.js.map